
import useVideoStore from '@/store/video';


export default function useVideoApoyo(rol){

    const video_store = useVideoStore();
    const items = ref([])

    const rol_name = computed(() => {
      if(rol ){
        return rol.value;
      }
      return 'Todos';
    });


    const isSortDirDesc = ref(true)
    const sortBy = ref('id')
    const searchQuery = ref('')
    const perPage = ref(25)
    const currentPage = ref(1)
    const total = ref(0);
    
    const dataMeta = computed(() => {
      const localItemsCount = items.value.length
      return {
         from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
         to: perPage.value * (currentPage.value - 1) + localItemsCount,
         of: total.value,
      }
    });

    const fetchData = (next) => {
      
      video_store.fetchData({
        q       : searchQuery.value,
        sortBy  : sortBy.value,
        sortDesc: isSortDirDesc.value,
        perPage : perPage.value,
        page    : currentPage.value,
        rol_name:rol_name.value
      }).then(({total:all,videos:vids}) => {
        total.value = all;
        next(vids);
      })
      .catch(e => {
        toast.error("Error al cargar los videos de apoyo");
      });

    }  
    
    const refetchData = () => {
     fetchData((its) => {
      items.value = its;
     })
    };  


    watch([currentPage, perPage, searchQuery], () => {
      refetchData();
    });

    return {
      refetchData,
      fetchData,
      dataMeta,
      items,
      total,
      isSortDirDesc,
      sortBy,
      searchQuery,
      perPage,
      currentPage,
    };

}